import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontPlayfairDisplay, fontRoboto, transientOptions } from "shared/lib/styles";

import type { entityLinkNameSize } from "scmp-app/components/header/features/entity-link";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

type ContainerProps = ResponsiveStyledProps & {
  $isMagazineStyle?: boolean;
  $size: entityLinkNameSize;
};

export const Container = styled("div", { ...transientOptions })<ContainerProps>`
  align-items: center;

  font-weight: 700;
  font-size: ${props => (props.$size === "large" ? "14px" : "12px")};
  font-family: ${fontRoboto};
  line-height: ${props => (props.$size === "large" ? "16px" : "14px")};
  white-space: nowrap;

  ${({ $isMagazineStyle }) =>
    $isMagazineStyle &&
    css`
      font-weight: 700;
      font-size: 14px;
      font-family: ${fontPlayfairDisplay};
      line-height: 19px;
    `}

  ${responsiveStyles}

  a {
    color: #001246;
  }
`;
